import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/Authcontext";

const Text = () => {
  const { contextData } = useContext(AuthContext);
  const [text, settext] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // new state variable for error message
  const { id, id2 } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    userisinformation();
    gettexte();
  }, []);

  const gettexte = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/text/${id2}/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    settext(responce.data);
  };

  const handelmarkasdone = async () => {
    let responce;
    try {
      responce = await axios.post(
        `https://pfebackend-zbz0.onrender.com/api/user/text/${id2}/`,
        null,
        {
          headers: {
            Authorization: `Bearer ${contextData.authTokens.access}`,
          },
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }

    navigate(`/formation/${id}`);
  };

  const userisinformation = async () => {
    let responce;
    if (contextData.user) {
      try {
        responce = await axios.get(
          `https://pfebackend-zbz0.onrender.com/api/user/formation/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${contextData.authTokens.access}`,
            },
          }
        );
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setErrorMessage(
            "Sorry, there was a problem with the server. Please try again later."
          );
        }
        return;
      }
      if (!responce.data) {
        navigate("/notallowed");
      }
    } else {
      navigate("/notallowed");
    }
  };

  function TextComponent(text) {
    if (text) {
      const paragraphs = text.split("\n");

      const renderedParagraphs = paragraphs.map((paragraph, index) => (
        <p className="textoftext" key={index}>
          {paragraph}
        </p>
      ));

      return <>{renderedParagraphs}</>;
    }
  }

  return (
    <>
      <div className="big-text--container">
        {errorMessage && (
          <div className=" erroremailexiste">{errorMessage}</div>
        )}
        <div className="text--container">
          <p className="">{TextComponent(text.text)}</p>
        </div>
      </div>
      <div className="markasdonbutton">
        <button className="btn-markasdone" onClick={handelmarkasdone}>
          Mark as Done
        </button>
      </div>
    </>
  );
};

export default Text;
